import {combineReducers, configureStore, createListenerMiddleware} from '@reduxjs/toolkit';
import {setupListeners} from '@reduxjs/toolkit/query/react';
import {persistStore, persistReducer, KEY_PREFIX} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {api} from './services/api';
import authReducer from '../features/auth/authSlice';
import coreReducer from '../features/core/coreSlice';
import demoReducer from '../features/demo/demoSlice';
import integrationDemoReducer from '../features/integration-demo/integrationDemoSlice';
import personReducer from '../features/person/personSlice';

const listenerMiddleware = createListenerMiddleware();

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['auth'],
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    [api.reducerPath]: api.reducer,
    auth: authReducer,
    core: coreReducer,
    demo: demoReducer,
    integrationDemo: integrationDemoReducer,
    person: personReducer,
  }),
);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({serializableCheck: false}).concat(listenerMiddleware.middleware).concat(api.middleware),
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
setupListeners(store.dispatch);

window.addEventListener('storage', (e) => {
  if (e.key != null && e.key.includes(KEY_PREFIX)) {
    const oldToken = getTokenFromStoredState(e.oldValue);
    const newToken = getTokenFromStoredState(e.newValue);
    if (oldToken !== newToken) {
      if (newToken != null && window.location.pathname === '/sign-in') {
        window.location.replace('/');
      } else {
        window.location.reload();
      }
    }
  }
});

function getTokenFromStoredState(value: string | null) {
  if (value == null) {
    return null;
  }

  let token: string | null = null;

  try {
    const storedState = JSON.parse(value);
    const auth = JSON.parse(storedState.auth);
    token = auth.token ?? null;
  } catch (e) {}

  return token;
}
